import React from 'react';
import DatePicker from 'react-datepicker';
import AccessTimeOutlinedIcon from '@mui/icons-material/AccessTimeOutlined';
import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { PLACEHOLDER_COLOR } from './manageEventFieldStyles';
import { parseTimeToDate, formatTimeFromDate, formatTimeLabel } from '../eventTimeUtils';
import 'react-datepicker/dist/react-datepicker.css';

const TimeInput = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'hasError',
})(({ theme, hasError }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  width: '100%',
  height: 56,
  padding: theme.spacing(0, 1.5),
  border: `1px solid ${hasError ? theme.palette.error.main : theme.palette.divider}`,
  borderRadius: 10,
  backgroundColor: theme.palette.background.paper,
  cursor: 'pointer',
  boxSizing: 'border-box',
  '&:hover': {
    borderColor: hasError ? theme.palette.error.main : theme.palette.text.disabled,
  },
}));

const pickerWrapperSx = {
  width: '100%',
  '& .react-datepicker-wrapper': {
    width: '100%',
    display: 'block',
  },
};

const EventTimePicker = ({ label, value, placeholder, onChange, error, helperText }) => {
  const selected = parseTimeToDate(value);
  const displayValue = value ? formatTimeLabel(value) : '';

  return (
    <Box>
      {label && (
        <Typography
          variant="caption"
          sx={{ display: 'block', mb: 0.75, color: 'text.secondary', fontSize: '0.75rem' }}
        >
          {label}
        </Typography>
      )}
      <Box sx={pickerWrapperSx}>
        <DatePicker
          selected={selected}
          onChange={(date) => onChange(formatTimeFromDate(date))}
          showTimeSelectOnly
          showTimeSelect
          timeIntervals={15}
          timeCaption="Time"
          dateFormat="h:mm aa"
          placeholderText={placeholder}
          customInput={
            <TimeInput hasError={Boolean(error)}>
              <Typography
                variant="body2"
                sx={{
                  color: displayValue ? 'text.primary' : PLACEHOLDER_COLOR,
                  fontSize: '0.875rem',
                }}
              >
                {displayValue || placeholder}
              </Typography>
              <AccessTimeOutlinedIcon sx={{ fontSize: 20, color: PLACEHOLDER_COLOR }} />
            </TimeInput>
          }
        />
      </Box>
      {helperText && (
        <Typography variant="caption" sx={{ color: '#d32f2f', mt: 0.5, display: 'block' }}>
          {helperText}
        </Typography>
      )}
    </Box>
  );
};

export default EventTimePicker;
